import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, ListItem, Chip, CardContent, Grid, Card, IconButton, CircularProgress, List, Paper, useTheme, Backdrop } from '@material-ui/core'
import { baseApiUrl } from '../dataProvider/sails';
import { makeStyles } from '@material-ui/core/styles'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import DialogChooseFile from '../file-management/file-management-dialog'
import { useDataProvider, useTranslate, usePermissions, Loading } from 'react-admin'

import { useHistory } from 'react-router-dom'
import TextField from '../CustomizedUIs/CustomTextFiled'
import { isImage, isMedia } from '../utils';
import { red, pink } from '@material-ui/core/colors';
import ic_computer from '../assets/icons/computer.png'
import ic_folder from '../assets/icons/folder-empty.png'
import CustomPopover from '../CustomizedUIs/CustomPopoverArrow'
import axios from 'axios'
import {
    usePopupState,
    bindToggle
} from 'material-ui-popup-state/hooks'

import TextButton from '../CustomizedUIs/TextButton';


const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({

    borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        background: 'white',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
    title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
}));

export function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress size={80} {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="body1" component="div" style={{ color: 'white' }}>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}



const FormUpdate = ({ id, loading, setLoading, ...props }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const history = useHistory()
    const { permissions, loaded } = usePermissions();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [openType, setOpenType] = useState(false)
    const [openCategory, setOpenCategory] = useState(false)
    const [messsageError, setMessageError] = useState('')
    const [file, setFile] = useState()
    const translate = useTranslate()
    const [category, setCategory] = useState()
    const logoPopupState = usePopupState({ variant: 'popper', popupId: 'pickLogo' });
    const [saveLoading, setSaveLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const theme = useTheme()
    const [textValue, setTextValue] = useState({
        name: '',
        link: ''

    })
    const [error, setError] = useState({
        name: { status: id ? false : true, messsage: '' },
        link: { status: id ? false : true, messsage: '' },
    })

    const [url, setUrl] = useState('')
    const [logo, setLogo] = useState()
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })
    const [categories, setCategories] = useState([])
    const [isError, setIsError] = useState(id ? false : true)
    const [newCategory, setNewCategory] = useState('')
    const [openCreate, setOpenCreate] = useState(false)

    // const createCategory = (value) => {
    //     dataProvider('CREATE', "medias/createcategory", {
    //         data: {
    //             name: value
    //         }
    //     })
    //         .then(({ data }) => {
    //             var temps = [...categories]
    //             temps.unshift(data)
    //             setCategories(temps)
    //             setNewCategory('')
    //             setOpenCreate(false)
    //         })
    //         .catch(error => {
    //             setNewCategory('')
    //             console.error('Create:', error);
    //         })
    // }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleOpenFileDialog = (type) => {
        setOpenFile({
            status: true,
            defaultId: type === 'logo' ? 4 : 3,
            format: type === 'logo' ? isImage : isMedia,
            setResponse: type === 'logo' ? setLogo : setFile
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }


    const handleOpenType = () => {
        setOpenType(!openType)
    }

    const handleOpenCategory = () => {
        setOpenCategory(!openCategory)
    }
    const onChangeCheckBox = (index) => {
        let temps = categories.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setCategories(temps)
    }


    const getCategory = () => {
        //setLoading(true);
        dataProvider('GET_LIST', "services/find-category", {
            filter: {
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            setCategories(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }


    const handleCancel = () => {
       history.push('/ExternalService')
    }
    const fileBrowserOnChangeLogo = event => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        newFile.fd = URL.createObjectURL(file)
        setLogo(newFile)
        logoPopupState.close()
    }



    const onChangTextValue = (event, name) => {

        setTextValue({
            ...textValue, [name]: event.target.value
        })

        if (event.target.value === '')
            setError({
                ...error, [name]: { status: true, messsage: 'required' }
            })
        else
            setError({
                ...error, [name]: { status: false, messsage: '' }
            })

    }


    const onCreate = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }
        //setLoading(true)
        let data = new FormData()
        let body = {
            name: textValue.name,
            category: category.id,
            link: textValue.link,
            logo: logo.id || null
        }
        data.append('data', JSON.stringify(body))
        if (!logo.id)
            data.append('file', logo.file)
        axios
            .post(`${baseApiUrl}/services`, data, config)
            .then(({ data }) => {
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/ExternalService',
                        state: {
                            status: true,
                            name: data.data.name,
                            message: translate(`pos.relatives.createRelative.success`)
                        }
                    });
                }, 3000)
                // setSaveLoading(false)
                // props.setCreating(false)
                // props.setShowSnackbar({
                //     status: true,
                //     name: data.data.name,
                //     message: translate(`pos.relatives.createRelative.success`)

                // })
                // setTimeout(() => props.setShowSnackbar({ status: false }), 6000)
            })
            .catch(error => {
                setSaveLoading(false)
                setMessageError(error.response.data.message)
            })
    }

    const onEdit = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }

        //setLoading(true)
        let data = new FormData()
        let body = {
            name: textValue.name,
            category: category.id,
            link: textValue.link,
            logo: logo.id || null
        }
        data.append('data', JSON.stringify(body))
        if (!logo.id)
            data.append('file', logo.file)
        axios
            .put(`${baseApiUrl}/services/${id}`, data, config)
            .then(({ data }) => {
                // setSaveLoading(false)
                // props.setEditing({ status: false })
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/ExternalService',
                        state: {
                            status: true,
                            name: data.data[0].name,
                            message: translate(`pos.relatives.editRelative.success`)
                        }
                    });
                }, 3000)
                // props.setShowSnackbar({
                //     status: true,
                //     name: data.data[0].name,
                //     message: translate(`pos.relatives.editRelative.success`)
                // })
                // setTimeout(() => props.setShowSnackbar({ status: false }), 6000)
            })
            .catch(error => {
                setSaveLoading(false)
                setMessageError(error.response.data.message)
            })
    }

    const pickCategoryValue = (value) => {
        setCategory(value)
        setOpenCategory(false)
    }



    useEffect(() => {
        setIsError(error.name.status || error.link.status || !logo || !category)
    }, [error, logo, category])

    useEffect(() => {
        if (id) {
            setTextValue({
                name: props.data.name,
                link: props.data.link
            })
            setCategory(props.data.category)
            setLogo(props.data.logo)
        }

        getCategory()
    }, [])

    if (loading) return <Loading />
    if (!categories) return null
    if (!loaded) return null

    return (
        <Box>
            <Backdrop style={{ zIndex: 1000 }} open={saveLoading} >
                <CircularProgressWithLabel value={progress} />
            </Backdrop>
            {
                messsageError != "" && (
                    <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                        <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                    </Box>
                )
            }
            <Box my={2}>
                <TextField
                    required
                    style={{ width: 500 }}
                    variant='filled'
                    label={translate(`pos.common.name`)}
                    error={error.name.status && error.name.messsage !== ''}
                    helperText={error.name.messsage}
                    onBlur={(event) => onChangTextValue(event, 'name')}
                    value={textValue.name}
                    onChange={(event) => onChangTextValue(event, 'name')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.channelNameTitle`)}
                        content={'This is name of service'}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <SelectBox
                    label={'Category'}
                    value={category ? <Typography className={classes.TextValue}>{category.name}</Typography> : ""}
                    open={openCategory}
                    handleClick={handleOpenCategory}
                    required={true}
                >
                    {
                        categories.map(item => (
                            <ListItem key={'type' + item.id} className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickCategoryValue(item)}>
                                <Typography className={classes.TextValue}>{item.name}</Typography>
                            </ListItem>
                        ))
                    }
                    {/* <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Movie')}>
                        <Typography className={classes.TextValue}>Movie</Typography>
                    </ListItem>
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Instruction content')}>
                        <Typography className={classes.TextValue} >Instruction content</Typography>
                    </ListItem> */}

                </SelectBox>
            </Box>

            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label={'Link'}
                    value={textValue.link}
                    onChange={(event) => onChangTextValue(event, 'link')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={'Link'}
                        content={'This is link url of service'}
                        icon={<b>?</b>}
                    />} />
            </Box>

            <Box my={2}>
                <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                    <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                        <Grid>
                            {
                                logo &&
                                <Box className={classes.large}>
                                    <img style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }} src={typeof (logo) === 'string' ? baseApiUrl + '/media/' + logo : (logo.id ? baseApiUrl + '/media/' + logo.fd : logo.fd)} />
                                </Box>

                            }

                        </Grid>
                        <Grid>
                            <CardContent>
                                <Typography className={classes.TitleImage} gutterBottom>
                                    {`${translate(`pos.user.changeimage`)} *`}
                                </Typography>
                                <Box my={1}>
                                    <Button {...bindToggle(logoPopupState)} variant='contained' color='secondary'>{translate(`pos.media.chooseImage`)}</Button>
                                </Box>
                                <CustomPopover
                                    popupState={logoPopupState}
                                    zIndex={5000}
                                    placement='right-end'

                                >
                                    <Paper style={{ padding: theme.spacing(1) }}>
                                        <List>
                                            <ListItem>
                                                <Typography className={classes.typography} style={{ fontWeight: 500, fontFamily: 'UniviaPro-Medium', marginRight: theme.spacing(1) }}>
                                                    {translate(`pos.infochannel.fileFormat`)}
                                                </Typography>
                                            </ListItem>
                                            <ListItem button>
                                                <img src={ic_computer} width={19} height={19}></img>
                                                <Typography className={classes.typography} style={{ cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.computer`)}</Typography>
                                                <input type='file' accept="image/*" onChange={fileBrowserOnChangeLogo} className={classes.input} />
                                            </ListItem>
                                            <ListItem button onClick={() => {
                                                logoPopupState.close()
                                                handleOpenFileDialog('logo')
                                            }}>
                                                <img src={ic_folder} width={19} height={19}></img>
                                                <Typography className={classes.typography} style={{ marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.fileManager`)}</Typography>

                                            </ListItem>

                                            <Box display='flex' justifyContent='flex-end'>
                                                <Button size='small' color='primary' onClick={() => logoPopupState.close()}>{translate(`pos.common.close`)}</Button>
                                            </Box>
                                        </List>
                                    </Paper>
                                </CustomPopover>
                            </CardContent>
                        </Grid>
                    </Grid>
                </Card>

            </Box>
            <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                <TextButton style={{ marginRight: '30px' }} onClick={handleCancel} />

                <Button disabled={isError || loading} style={{ pading: 8 }} variant='contained' color='primary' onClick={id ? onEdit : onCreate}>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        id ? translate(`pos.common.save`) : translate(`pos.common.create`)
                    }
                    {/* {id ? translate(`pos.common.save`) : translate(`pos.common.create`)} */}
                </Button>
            </Box>
            <DialogChooseFile
                formats={openFile.format}
                defaultId={openFile.defaultId}
                open={openFile.status}
                pickerMode='pickMediaOnly'
                handleClose={handleClose}
                setChooseValue={openFile.setResponse}
                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
            />
        </Box >
    )


}
export default FormUpdate